import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ user, children, onRequireAuth }) => {
  const location = useLocation();

  useEffect(() => {
    if (!user) {
      onRequireAuth();
    }
  }, [user, onRequireAuth]);

  if (!user) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default ProtectedRoute;
